// extracted by css-extract-rspack-plugin
var _1 = "v9";
var _2 = "br";
var _3 = "cl";
var _4 = "wa";
var _5 = "e6";
export { _1 as "center", _2 as "left", _3 as "panelComponent", _4 as "right", _5 as "titleText" }
